<template>
    <div id="popup-review-detail">
        <vs-popup class="review-popup" title="Review info" :active.sync="popupConfig.isOpen">
            <vs-tabs :color="colorx" class="review-popup-content bg-white">
                <vs-tab @click="colorx = 'primary'" label="Detail" class="activeChild">
                    <div class="con-tab-ejemplo review">
                       dfgdfgdf
                    </div>
                </vs-tab>

                <vs-tab @click="colorx = 'success'" label="History">
                    <div class="con-tab-ejemplo history">
                        sgdfdzfg
                    </div>
                </vs-tab>
            </vs-tabs>
        </vs-popup>
    </div>
</template>
<script>
    export default {
        name: 'vs-popup-review-detail',
        props: {
           popupConfig: {
               type: Object,
               required: true
           } 
        },
        data() {
            return {
                colorx: 'primary'
            }
        }
    }
</script>